import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Box from "@material-ui/core/Box";
import { default as UUID } from "node-uuid";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { Card, CardActions, CardHeader } from "@material-ui/core";

import SongPartSelect from "./SongPartSelect";
import SongPartActions from "./SongPartActions";
import SongPartLength from "./SongPartLength";
import SongDetailsInput from "./SongDetailsInput";


const useStyles = makeStyles((theme) => ({
  root: {
    width: 400,
  },
  form: {
    width: "100%",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  addItem: {
    background: theme.palette.action.hover,
    "&:hover": {
      background: theme.palette.action.active,
    },
  },
}));

const SongPartsInput = (props) => {
  const classes = useStyles();
  const [songData, setSongData] = React.useState([
    {
      id: UUID.v4(),
      part: "Intro",
      length: 4,
    },
    {
      id: UUID.v4(),
      part: "Verse",
      length: 8,
    },
    {
      id: UUID.v4(),
      part: "Chorus",
      length: 8,
    },
  ]);

  const handleDelete = (id) => {
    setSongData((songData) => songData.filter((el) => el.id !== id));
  };

  const handleAdd = () => {
    setSongData((songData) =>
      songData.concat({
        id: UUID.v4(),
        part: "Intro",
        length: 8,
      })
    );
  };

  const handlePartChange = (event, songPart) => {
    setSongData((songData) =>
      songData.map((element) =>
        element.id === songPart
          ? { ...element, part: event.target.value }
          : element
      )
    );
  };

  const handleValueChange = (songPart, event) => {
    console.log();
    if (event.target.value > 0) {
      setSongData((songData) =>
        songData.map((element) =>
          element.id === songPart
            ? { ...element, length: event.target.value }
            : element
        )
      );
    }
  };

  const handleSpecialChange = (songPart) => {
    setSongData((songData) =>
      songData.map((element) =>
        element.id === songPart ? { ...element, isSpecial: true } : element
      )
    );
  };

  return (
    <Card className={classes.root}>
      <form className={classes.form} autoComplete="off">
        <SongDetailsInput />
        <List className={classes.list}>
          {songData.map((songPart) => {
            return (
              <ListItem
                className={classes.listItem}
                key={songPart.id}
                role={undefined}
              >
                {songPart.isSpecial ? (
                  <div>
                    <SongPartSelect
                      handlePartChange={handlePartChange}
                      songPart={songPart}
                      wide={false}
                    />
                    <SongPartSelect
                      handlePartChange={handlePartChange}
                      songPart={songPart}
                      wide={false}
                    />
                  </div>
                ) : (
                  <SongPartSelect
                    handlePartChange={handlePartChange}
                    songPart={songPart}
                    wide={true}
                  />
                )}

                <SongPartLength
                  songPart={songPart}
                  handleValueChange={handleValueChange}
                />

                <SongPartActions
                  songPart={songPart}
                  handleDelete={handleDelete}
                  handleSpecialChange={handleSpecialChange}
                />
              </ListItem>
            );
          })}
          <ListItem
            className={classes.addItem}
            role={undefined}
            dense
            button
            alignItems="center"
            onClick={handleAdd}
            key={UUID.v4()}
          >
            <Box mx="auto">
              <AddIcon />
            </Box>
          </ListItem>
        </List>

        <CardActions>
          <Button
            color="primary"
            href={props.midi(songData)}
            key={UUID.v4()}
            download="music.mid"
          >
            Downlad
          </Button>
          <Button
            color="primary"
            href={props.midi(songData)}
            key={UUID.v4()}
            download="music.mid"
          >
            Save
          </Button>
        </CardActions>
      </form>
    </Card>
  );
};

export default SongPartsInput;
